import React from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { DocumentSearch24Regular } from '@fluentui/react-icons';
import './GuideComponents.css';

export interface GuideEmptyStateProps {
  /** Título bold ("Todavía no hay conceptos"). */
  title: React.ReactNode;
  /** Ayuda secundaria. */
  text?: React.ReactNode;
  /** Ícono (por defecto, documento con lupa). `null` lo oculta. */
  icon?: React.ReactNode | null;
  /** Acción, normalmente un botón primario. */
  action?: React.ReactNode;
  className?: string;
  'data-testid'?: string;
}

/**
 * Estado vacío de la guía ("Menú, estado vacío y carga"): recuadro punteado, ícono, título bold,
 * ayuda secundaria y botón primario opcional.
 */
export const GuideEmptyState = ({ title, text, icon, action, className, 'data-testid': testId }: GuideEmptyStateProps) => (
  <div className={mergeClasses('ichtys-empty', className)} data-testid={testId}>
    {icon !== null && (
      <span className="ichtys-empty__icon" aria-hidden="true">
        {icon ?? <DocumentSearch24Regular />}
      </span>
    )}
    <span className="ichtys-empty__title">{title}</span>
    {text && <span className="ichtys-empty__text">{text}</span>}
    {action && <div className="ichtys-empty__action">{action}</div>}
  </div>
);

export default GuideEmptyState;
